import styled from 'styled-components';
import {
    Button,
    Paragraph,
    spaceMixin,
} from '@zillow/constellation';
import { HR } from '@zillow/zrs-comet';

export const StyledYellowHR = styled(HR)`
    && {
        width: 124px;
        margin-top: 0;
        margin-bottom: ${spaceMixin(6)};
        ::before,
        ::after {
            height: 2px;
        }
    }
`;

export const CenteredParagraph = styled(Paragraph)`
    text-align: center;
`;

export const StyledButton = styled(Button)`
    margin-bottom: ${spaceMixin('lg')};
`;
